export const FOREVER = '9999-12-31T23:59:59.000Z'

export const muteOptions = [
  { id: '1h', label: '1 hour', ms: 60 * 60 * 1000 },
  { id: '8h', label: '8 hours', ms: 8 * 60 * 60 * 1000 },
  { id: '24h', label: '24 hours', ms: 24 * 60 * 60 * 1000 },
  { id: 'forever', label: 'Until I unmute', ms: null },
] as const

export type MuteOptionId = (typeof muteOptions)[number]['id']

export function mutedUntilFor(id: MuteOptionId, now = Date.now()): string {
  const option = muteOptions.find((o) => o.id === id)!
  return option.ms === null ? FOREVER : new Date(now + option.ms).toISOString()
}

export function describeMute(mutedUntil: string | null, now = Date.now()): string | null {
  if (!mutedUntil) return null
  const until = new Date(mutedUntil).getTime()
  if (until <= now) return null
  if (mutedUntil.startsWith('9999')) return 'Muted until you unmute'
  return `Muted until ${new Date(mutedUntil).toLocaleString('en-GB', { weekday: 'short', hour: '2-digit', minute: '2-digit' })}`
}
